import React, { Component, useEffect, useRef } from 'react';
import { Modal, message, Table, Form, Input, Button, Select, Card, Row, Col } from 'antd';
import client from '../../feathers';
import requireAuth from "../requireAuth";
import Layout from "../layout";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import XLSX from 'xlsx';
import moment from 'moment';


const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};

const text = 'Are you sure to delete this item?';


class IndexAppLogs extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dataSource: [],
      totalPagination: 0,
      CurrentPagination: 1,
      loading: false,
      visible: false,
      id: '',
    }
  }

  componentWillMount() {

    this.setState({ loading: true });
    client.authenticate()
      .then(() => {
        return client.service('applogs').find({
          query: {
            propertyId: this.props.user.info.propertyId._id,
            $populate: 'items.invoiceId',
            $limit: 20,
            $sort: {
              createdAt: -1
            }
          }
        })
      })
      .then((res) => {
        this.setState({
          dataSource: res.data,
          totalPagination: res.total,
          loading: false
        });
      })
      .catch((err) => {
        console.error('Error loading applogs:', err);
      })
  }

  convertDate(date = null) {
    let tempDate = new Date(date);
    let d = tempDate.getDate();
    let m = tempDate.getMonth() + 1
    let y = tempDate.getFullYear();
    return date ? d + '/' + m + '/' + y : '';
  }

  showModal = (e, id) => {
    this.setState({
      id: id,
      visible: true,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleOk = e => {

    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        axios.get(`${client.io.io.uri}applogs-invoices`, {
          params: {
            id: this.state.id,
            email: values.email,
            companyId: this.props.user.info.propertyId._id
          },
          headers: {
            'Authorization': client.settings.storage.storage['feathers-jwt']
          }
        });
        this.setState({
          visible: false,
        });
        message.success('Email will be sent in a while.');
      }
    })
  };

  handlePageChange = (page) => {
    this.setState({
      CurrentPagination: page,
      loading: true
    });

    client.authenticate()
      .then((res) => {

        return client.service('applogs').find({
          query: {
            propertyId: this.props.user.info.propertyId._id,
            $populate: 'items.invoiceId',
            $limit: 20,
            $skip: (page - 1) * 20,
            $sort: {
              createdAt: -1
            }
          }
        })
      })
      .then((res) => {

        this.setState({
          dataSource: res.data,
          totalPagination: res.total,
          loading: false
        });
      })
      .catch((err) => {
        console.error('Error loading applogs page:', err);
      });

  }

  handleDownloadExcel = (event, record) => {
    event.preventDefault();

    // Show loading message
    message.loading('Generating Excel file...', 0);

    // Fetch all invoices for this batch
    client.authenticate()
      .then((res) => {
        return client.service('invoices').find({
          query: {
            batchId: record.batchId,
            $populate: ['propertyunitId', 'invoiceItems'],
            $limit: 1000, // Get all invoices for this batch
            $sort: {
              'propertyunitId.referenceId': 1
            }
          }
        });
      })
      .then(async (invoicesRes) => {
        // Calculate prepayments for all invoices in a single batch query
        console.log('💰 Starting prepayment calculation for', invoicesRes.data.length, 'invoices');
        let invoicesWithPrepayments = [];

        try {
          // Get all invoice IDs for batch query
          const invoiceIds = invoicesRes.data.map(invoice => invoice._id);

          // Single query to get all prepayment transactions for all invoices
          const allPrepaymentTxns = await client.service('ledger-transactions').find({
            query: {
              invoiceId: { $in: invoiceIds },
              $or: [
                { eventCode: 'PREPAYMENT' },
                { remark: 'PREPAYMENT' },
                { description: { $regex: 'prepayment', $options: 'i' } }
              ],
              $limit: 5000 // Higher limit for batch query
            }
          });

          console.log('💰 Found', allPrepaymentTxns.data.length, 'prepayment transactions total');

          // Group prepayment transactions by invoice ID
          const prepaymentsByInvoice = {};
          allPrepaymentTxns.data.forEach(txn => {
            if (!prepaymentsByInvoice[txn.invoiceId]) {
              prepaymentsByInvoice[txn.invoiceId] = [];
            }
            prepaymentsByInvoice[txn.invoiceId].push(txn);
          });

          // Calculate prepayments for each invoice
          invoicesWithPrepayments = invoicesRes.data.map((invoice, index) => {
            const prepaymentTxns = prepaymentsByInvoice[invoice._id] || [];
            const totalPrepayment = prepaymentTxns.reduce((sum, txn) => {
              return sum + (txn.debitAmount || 0);
            }, 0);

            // Debug logging for first few invoices
            if (index < 3) {
              console.log(`💰 Invoice ${invoice.invoiceNo}:`, {
                invoiceId: invoice._id,
                prepaymentTxnsFound: prepaymentTxns.length,
                totalPrepayment,
                sampleTxns: prepaymentTxns.slice(0, 2)
              });
            }

            return {
              ...invoice,
              calculatedPrepayment: totalPrepayment
            };
          });

        } catch (error) {
          console.error('Error in batch prepayment calculation:', error);
          // Fallback: set all prepayments to 0
          invoicesWithPrepayments = invoicesRes.data.map(invoice => ({
            ...invoice,
            calculatedPrepayment: 0
          }));
        }

        return { data: invoicesWithPrepayments };
      })
      .then(async (invoicesRes) => {
        if (!invoicesRes.data || invoicesRes.data.length === 0) {
          message.destroy();
          message.warning('No invoices found for this batch.');
          return;
        }

        // Get unique ledger account IDs from the invoices
        const ledgerAccountIds = [];
        const unitToLedgerMap = {};

        console.log('🔍 Debug: First few invoices structure:', invoicesRes.data.slice(0, 3).map(inv => ({
          invoiceNo: inv.invoiceNo,
          propertyunitId: inv.propertyunitId,
          hasPropertyUnit: !!inv.propertyunitId,
          hasLedgerAccountId: !!(inv.propertyunitId && inv.propertyunitId.ledgerAccountId)
        })));

        for (const invoice of invoicesRes.data) {
          if (invoice.propertyunitId && invoice.propertyunitId.ledgerAccountId) {
            const ledgerAccountId = invoice.propertyunitId.ledgerAccountId;
            if (!ledgerAccountIds.includes(ledgerAccountId)) {
              ledgerAccountIds.push(ledgerAccountId);
            }
            unitToLedgerMap[invoice.propertyunitId.referenceId] = ledgerAccountId;
          }
        }

        // Get SOA balance data for all units
        let soaBalanceData = {};
        console.log('🔍 Debug: Ledger Account IDs found:', ledgerAccountIds);
        console.log('🔍 Debug: Unit to Ledger Map:', unitToLedgerMap);

        if (ledgerAccountIds.length > 0) {
          try {
            console.log('📡 Fetching SOA balance data for', ledgerAccountIds.length, 'accounts');

            // Process in concurrent batches of 10 for much faster performance
            const batchSize = 10;
            const batches = [];

            // Create all batches
            for (let i = 0; i < ledgerAccountIds.length; i += batchSize) {
              batches.push(ledgerAccountIds.slice(i, i + batchSize));
            }

            console.log(`🚀 Processing ${batches.length} batches concurrently with ${batchSize} accounts each`);

            // Process all batches concurrently
            const batchPromises = batches.map(async (batch, batchIndex) => {
              try {
                console.log(`📦 Starting batch ${batchIndex + 1}/${batches.length} with ${batch.length} accounts`);

                const soaResponse = await axios.get(`${client.io.io.uri}SOABalanceList`, {
                  params: {
                    startDate: new Date('1900-01-01'),
                    endDate: new Date(),
                    accountList: batch
                  },
                  headers: {
                    'Authorization': client.settings.storage.storage['feathers-jwt']
                  },
                  timeout: 60000 // 1 minute timeout per batch
                });

                console.log(`✅ Batch ${batchIndex + 1} completed with ${(soaResponse.data && soaResponse.data.length) || 0} results`);
                return soaResponse.data || [];
              } catch (batchError) {
                console.warn(`❌ Batch ${batchIndex + 1} failed:`, batchError.message);
                return []; // Return empty array for failed batches
              }
            });

            // Wait for all batches to complete
            const batchResults = await Promise.all(batchPromises);

            // Combine all results
            batchResults.forEach(batchData => {
              if (Array.isArray(batchData)) {
                batchData.forEach(item => {
                  console.log(`📊 Mapping ${item.ledgerAccountId} -> ${item.balance}`);
                  soaBalanceData[item.ledgerAccountId] = item.balance || 0;
                });
              }
            });

            console.log('🗺️ Final SOA Balance Data:', soaBalanceData);
          } catch (soaError) {
            console.warn('Could not fetch SOA balance data:', soaError);
            if (soaError.response && soaError.response.data) {
              console.warn('Error details:', soaError.response.data);
            }
            // Continue without SOA data
          }
        } else {
          console.warn('⚠️ No ledger account IDs found for SOA balance lookup');
        }

        // Destroy loading message
        message.destroy();

        // Prepare data for Excel
        const excelData = invoicesRes.data.map((invoice, index) => {
          const unitNo = invoice.propertyunitId ? invoice.propertyunitId.referenceId : 'N/A';
          const ledgerAccountId = unitToLedgerMap[unitNo];
          const soaBalance = ledgerAccountId ? (soaBalanceData[ledgerAccountId] || 0) : 0;

          // Calculate values for comparison
          const invoiceAmount = parseFloat((invoice.totalAmt || 0).toFixed(2));
          const previousOutstanding = parseFloat((invoice.previousOutstanding || 0).toFixed(2));
          const totalAmount = parseFloat((invoiceAmount + previousOutstanding).toFixed(2));

          // Debug logging for first few records
          if (index < 3) {
            console.log(`🔍 Excel Row ${index + 1}:`, {
              unitNo,
              invoiceAmount,
              previousOutstanding,
              totalAmount,
              ledgerAccountId,
              soaBalance,
              hasLedgerAccountId: !!ledgerAccountId,
              soaBalanceDataForThisAccount: soaBalanceData[ledgerAccountId],
              difference: (soaBalance - totalAmount).toFixed(2),
              match: Math.abs(soaBalance - totalAmount) < 0.01 ? 'Match' : 'No match'
            });
          }

          return {
            'No.': index + 1,
            'Unit No': unitNo,
            'Invoice No': invoice.invoiceNo,
            'Invoice Date': moment(invoice.invoiceDate).format('DD/MM/YYYY'),
            'Invoice Amount': invoiceAmount,
            'Previous Outstanding': previousOutstanding,
            'Prepayment': parseFloat((invoice.calculatedPrepayment || 0).toFixed(2)),
            'Total Amount': totalAmount,
            'SOA Balance': parseFloat(soaBalance.toFixed(2)),
            'Match': Math.abs(soaBalance - totalAmount) < 0.01 ? 'Match' : 'No match'
          };
        });

        // Create workbook and worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        const columnWidths = [
          { wch: 5 },   // No.
          { wch: 12 },  // Unit No
          { wch: 15 },  // Invoice No
          { wch: 12 },  // Invoice Date
          { wch: 15 },  // Invoice Amount
          { wch: 18 },  // Previous Outstanding
          { wch: 12 },  // Prepayment
          { wch: 15 },  // Total Amount
          { wch: 15 }   // SOA Balance
        ];
        worksheet['!cols'] = columnWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoice Details');

        // Generate filename with timestamp
        const timestamp = moment().format('YYYYMMDD_HHmmss');
        const filename = `Invoice_Batch_${record.batchId}_${timestamp}.xlsx`;

        // Save file
        XLSX.writeFile(workbook, filename);

        message.success(`Excel file "${filename}" has been downloaded successfully!`);
      })
      .catch((err) => {
        message.destroy();
        console.error('Error generating Excel:', err);
        message.error('Failed to generate Excel file. Please try again.');
      });
  };

  render() {
    const dataSource = this.state.dataSource;
    const totalPagination = this.state.totalPagination;
    const loading = this.state.loading;
    const { getFieldDecorator } = this.props.form;

    const columns = [
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 80,
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
        key: 'remark',
        width: 120,
      },
      {
        title: 'Total Invoices',
        dataIndex: 'invoiceCount',
        align: 'right',
        width: 100,
      },
      {
        title: 'Total Invoice Amount',
        dataIndex: 'totalInvoiceAmount',
        align: 'right',
        width: 150,
        render: (text, record) => (
          <span>
            {record.totalInvoiceAmount ? `RM ${record.totalInvoiceAmount.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'RM 0.00'}
          </span>
        ),
      },
      {
        title: 'Previous Outstanding',
        dataIndex: 'totalPreviousOutstanding',
        align: 'right',
        width: 150,
        render: (text, record) => (
          <span>
            {record.totalPreviousOutstanding ? `RM ${record.totalPreviousOutstanding.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'RM 0.00'}
          </span>
        ),
      },
      {
        title: 'Total Prepayment',
        dataIndex: 'totalPrepayment',
        align: 'right',
        width: 150,
        render: (text, record) => (
          <span>
            {record.totalPrepayment ? `RM ${record.totalPrepayment.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'RM 0.00'}
          </span>
        ),
      },
      {
        title: 'Total Net Amount',
        dataIndex: 'totalNetAmount',
        align: 'right',
        width: 150,
        render: (text, record) => (
          <span style={{ fontWeight: 'bold' }}>
            {record.totalNetAmount ? `RM ${record.totalNetAmount.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'RM 0.00'}
          </span>
        ),
      },
      {
        title: 'Created At',
        dataIndex: 'createdAt',
        width: 120,
        render: (text, record) => (
          <span>
            {this.convertDate(text)}
          </span>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        width: 250,
        render: (text, record) => (
          <Row gutter={8}>
            <Col span={4}><Button type='primary' size='small'><Link to={{ pathname: `/applogs/form/${record._id}` }} >View</Link></Button></Col>
            {/* <Col span={6}><Button type='primary' size='small' onClick={(event) => this.showModal(event, record._id)}>Send To Email</Button></Col> */}
            <Col span={6}><Button type='primary' size='small' onClick={(event) => this.handleDownloadExcel(event, record)}>Download</Button></Col>
          </Row>
        ),
      }
    ];

    return (
      <Layout>
        <Card
          loading={loading}
          title={'Recurring Invoice History'}
        >
          <Modal
            title="Send To Email"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <Form className="submit-form">

              <FormItem {...formItemLayout} label="Email">
                {getFieldDecorator('email', {
                  rules: [{
                    type: 'email', message: 'The input is not valid E-mail!'
                  }, { required: true, message: 'Please input E-mail!' }],

                })(
                  <Input placeholder="Email" />
                )}
              </FormItem>

            </Form>
          </Modal>




          <Table
            dataSource={dataSource}
            columns={columns}
            size={'small'}
            scroll={{ x: 1450 }}
            pagination={{
              defaultCurrent: 1,
              total: totalPagination,
              onChange: this.handlePageChange,
              pageSize: 20,
            }}
            rowKey='_id'
          />


        </Card>
      </Layout>
    );
  }
}


function mapStateToProps(state) {
  return {
    //accounts: state.accounts
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    //updateMode: updateMode
  }, dispatch);
}

export default requireAuth(connect(mapStateToProps, mapDispatchToProps)(Form.create()(IndexAppLogs)));
